import React, {useState, useEffect} from "react";

import {Grid, Dialog, DialogTitle, DialogActions, DialogContent, Typography} from "@mui/material";
import * as PropTypes from "prop-types";
import {ButtonSpacer} from "../../../../components/ButtonSpacer";
import {
    setFunction,
    saveFunction,
    unsetFunction,
    createFunction,
    listFunctionTemplates,
    getSharedMunicipalities,
    setYouthData,
    getYouthCardInfo,
    updateFunctionTemplate
} from "../../function.actions";
import {connect} from "react-redux";
import {getLocation} from "../../../location/location.actions";
import { useNavigate } from "react-router-dom";
import {
    handleCurrentDateCalulcations
} from "../../components/functionFormComponentUtils";
import {askUpdates, updateContentIdentifierChoices} from "../../../root/root.actions";
import {listLocations} from "../../../location/location.actions";
import {
    listMunicipalityUsersSilent,
    listOrganizations,
    getOrganizationTree, listMunicipalities, getMunicipality
} from "../../../municipality/municipality.actions";
import {useTranslation, withTranslation} from "react-i18next";
import { generateKey } from "../../../../utils";
import {selectButtonType} from "../../../../components/utils";
import {hasPermission, PERMISSION_CREATE_FUNCTION_ANY_MUNICIPALITY} from "../../../../permissions";
import {FunctionOrganizationAndLocationComp} from "./createFunction/functionOrganizationAndLocationComponent";
import {FunctionInformationComp} from "./createFunction/functionFunctionInformation";
import {FunctionTemplateTopComp} from "./functionTemplates/functionTemplateTop";
import { ButtonPrimary } from "../../../../components/newComponents/ButtonPrimary";
import { ButtonSecondary } from "../../../../components/newComponents/ButtonSecondary";
import { Prompt } from "../../../../components/newComponents/Prompt";

const FunctionTemplatesFormComponent = (props) => {
    const {
        onChange,
        editorActivated,
        shared,
        showShared,
        copyMode,
        fieldErrors = {},
        updateData,
        selectedMunicipality,
        selectedFunction,
        organizationList,
        organizationTree,
        locations,
        func,
        authenticatedUser,
        action,
        getSharedMunicipalities,
    } = props;

    const {t} = useTranslation('translation');
    
    const [updateDataForm, setUpdateDataForm] = useState(updateData);
    const [temporary, setTemporary] = useState(false);
    const [showOptions, setShowOptions] = useState(false)
    const [deleteClicked, setIsDeleteClicked] = useState(false)
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [isExistingTemplate, setIsExistingTemplate] = useState(false)
    const [createNewTemplate, setCreateNewTemplate] = useState(false)
    const [isSaving, setIsSaving] = useState(false);
    const [initialFunctionString, setInitialFunctionString] = useState(null);
    const [isDirty, setIsDirty] = useState(false)
    const [formKey, setFormKey] = useState(0);

    const navigate = useNavigate();

    useEffect(() => {
        if(selectedTemplate?.id) {
            setIsExistingTemplate(true)
        } else {
            setIsExistingTemplate(false)
        }
    }, [selectedTemplate])

    const markFormDirty = () => setIsDirty(true);

    const resetState = () => {
        setFormKey((key) => key + 1);
        setIsDirty(false);
    };

    useEffect( () => {
        props.askUpdates();
        props.listMunicipalities();
        props.listFunctionTemplates(props.selectedMunicipality.id);
        props.listLocations(props.selectedMunicipality.id);
        props.listOrganizations(props.selectedMunicipality.id);
        props.getOrganizationTree(props.selectedMunicipality.id, 10);
        props.getMunicipality(props.authenticatedUser.mainMunicipalityId)
        props.unsetFunction()
    }, [])

    useEffect(() => {
        if (copyMode) {
            if (selectedFunction.startDatetime) {
                selectedFunction.startTime = selectedFunction.startDatetime.split("T")[1];
            }
            if (selectedFunction.endDatetime) {
                selectedFunction.endTime = selectedFunction.endDatetime.split("T")[1];
            }
            handleCurrentDateCalulcations(selectedFunction);
            setFunction(selectedFunction);
        }
        if (selectedFunction.shared && selectedFunction.shareCode) {
            getSharedMunicipalities(selectedFunction.shareCode);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (initialFunctionString !== null) return;

        if (selectedFunction) {
            setInitialFunctionString(JSON.stringify(selectedFunction));
        }
    }, [selectedFunction, initialFunctionString]);

    useEffect(() => {
        if (updateDataForm) {
            setUpdateDataForm(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateDataForm])


    useEffect(() => {
        if (temporary) {
            setTemporary(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [temporary])

    const handleChange = (e) => {
        let data = {
            ...selectedFunction,
            [e.target.name]: e.target.value
        }
        props.setFunction(data);
    };

    const handleSelectedTemplate = (template) => {
        setSelectedTemplate(template);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsSaving(true)
        setCreateNewTemplate(true)
        setDialogOpen(true)
    };

    const dialogSubmit = () => {
        setIsSaving(true);

        const functionData = { ...selectedFunction };

        resetState()
        if (functionData.id) {
            props.saveFunction(functionData.id, functionData,
                () => { navigate('/function'); }
            );
        } else {
            props.createFunction(functionData, true, () => {
                setIsDirty(false);
                navigate('/function', {showSuccess: true, isTemplate: true});
            }, true);
        }
    }

    const handleDialogSaveExisting = (event) => {
        event.preventDefault();
        
        const data = { ...selectedFunction };
        const template = selectedTemplate;

        updateTemplate(event, data, template);
    }

    const handleTemplateSubmit = (event, props, functionTemplate) => {
        setIsSaving(true);
        setCreateNewTemplate(false)
        setDialogOpen(true)
    }

    const updateTemplate = (event, data, functionTemplate) => {
        if (!selectedTemplate) return;

        const functionData = { ...data };
        if (!functionData['municipalityId']) {
            functionData['municipalityId'] = selectedFunction.municipalityId;
        }
        //null check to prevent application crash
        if(!functionTemplate.id) return;

        props.updateFunctionTemplate(functionTemplate.id, functionData, (data) => {
            props.listFunctionTemplates(functionData['municipalityId']);
            navigate('/function', {showSuccess: true, isTemplate: true});
        });
    };

    const isDeleteClicked = () => {
        setIsDeleteClicked(true)
    }

    const handleClick = (event, callback) => {
        event.preventDefault()
        const data = {...selectedFunction}
        callback(event, data, selectedTemplate, props.selectedMunicipality);
    };

    const closeWithoutSaving = () => {
        setIsDirty(false);
        navigate('/function')
    }

    let actionButtons = [
        {
            type: "secondary",
            label: t('common.close_without_saving'),
            className: "function-cancel",
            onClick: closeWithoutSaving
        },
        {
            type: "primary",
            label: t('function.save_template'),
            className: "",
            onClick: handleSubmit
        }
    ];

    if (selectedTemplate?.id) {
        actionButtons.push({
            id: "edit",
            type: "primary",
            label: t("function.save_function_template_changes"),
            className: "save_template-button",
            onClick: handleTemplateSubmit
        });
    }

    /* Feel free to refactor or put into utils file */
    const insertAt = (array, index, obj) => {
        array.splice(index, 0, obj)
    }

    if(isExistingTemplate) {
        insertAt(actionButtons, 1, 
            {
                id: "delete",
                type: "delete",
                label: t("function.delete_function_template"),
                className: "delete_template-button",
                onClick: isDeleteClicked
            }
        )
    }

    let componentActionButtons = [];
    if (actionButtons) {
        actionButtons.forEach(function (button) {
            const key = generateKey('funcEditButton');
            selectButtonType(button, componentActionButtons, key, handleClick, button.id);
        });
    }

    const municipalitySelect = hasPermission(PERMISSION_CREATE_FUNCTION_ANY_MUNICIPALITY, authenticatedUser) || shared || showShared;

    if (!selectedFunction.municipalityId) {
        selectedFunction.municipalityId = selectedMunicipality.id;
    }
    if (!municipalitySelect && selectedFunction.municipalityId && selectedFunction.municipalityId !== selectedMunicipality.id) {
        selectedFunction.municipalityId = selectedMunicipality.id;
    }

    const sectionHasError = (errorFields) => {
        let returnValue = false;
        errorFields.forEach(errorField => {
            if (errorField in fieldErrors) {
                returnValue = true;
            }
        })
        return returnValue;
    }

    const showTemplateOptions = () => {
        setShowOptions((prev) => !prev)
        props.unsetFunction()
    }

    return (
        <form noValidate autoComplete="off" className={"function-container"} key={formKey} onChange={markFormDirty}>
            <Prompt
                when={isDirty && !isSaving && action !== 'share'}
                message={t("function.continue_without_saving")}
            />
            <Grid container sx={{flexDirection: 'row-reverse'}}>
                <FunctionTemplateTopComp
                    editorActivated={editorActivated}
                    locations={locations}
                    organizationTree={organizationTree}
                    action={'template'}
                    organizationList={organizationList}
                    handleChange={handleChange}
                    onChange={onChange}
                    showOptions={showOptions}
                    toggleShowOptions={showTemplateOptions}
                    sectionHasError={sectionHasError}
                    fieldErrors={func.functionFieldErrors}
                    deleteClicked={deleteClicked}
                    closeDeleteModal={() => setIsDeleteClicked(false)}
                    onTemplateSelect={handleSelectedTemplate}
                />
                {showOptions && (
                    <>
                        <Grid item xs={12} sx={{width: '100%', borderTop: '1px solid rgba(0,0,0,0.3)'}}>
                            <FunctionOrganizationAndLocationComp
                                editorActivated={editorActivated}
                                action={'template'} 
                                handleChange={handleChange}
                                sectionHasError={sectionHasError}
                                fieldErrors={func.functionFieldErrors}
                            />
                        </Grid>
                        <Grid item xs={12} sx={{width: '100%', borderTop: '1px solid rgba(0,0,0,0.3)'}}>
                            <FunctionInformationComp
                                editorActivated={editorActivated}
                                action={'template'}
                                onChange={onChange}
                                handleChange={handleChange}
                                sectionHasError={sectionHasError}
                                fieldErrors={func.functionFieldErrors}
                                forceOrganizer={false}
                            />
                        </Grid>
                    </>
                )}
            </Grid>
            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>{createNewTemplate ? (
                    <>
                        {t('function.new_template_save')}
                    </>
                ) : (
                    <>
                        {t('function.template_change')}
                    </>
                )}
                </DialogTitle>
                    <DialogContent>
                        <Grid container>
                            <Grid size={{xs: 12, sm: 12}} sx={{alignItems: 'center'}}>
                                {isExistingTemplate && createNewTemplate ? (
                                    <Typography>
                                        {t('function.new_template_from_existing_1')}<strong>{selectedTemplate?.templateName}</strong> {t('function.new_template_from_existing_2')}
                                    </Typography>
                                ) : (
                                    <Typography tabIndex={0}>
                                        {!createNewTemplate ? (
                                            <>
                                                {t('function.existing_template_edit_1')}<strong>{selectedTemplate?.templateName}.</strong>{t('function.existing_template_edit_2')}
                                            </>
                                        ) : (
                                            <>
                                                {t('function.new_template_creation')}
                                            </>
                                        )}
                                    </Typography>
                                )}
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid size={{xs: 12, sm: 4}}>
                            {isExistingTemplate && !createNewTemplate ? (
                                <ButtonPrimary 
                                    onClick={handleDialogSaveExisting}
                                    sx={{cursor: 'pointer', whiteSpace: "nowrap"}}
                                >
                                    {t('function.save_function_template_changes')}
                                </ButtonPrimary>
                            ) : (
                                <ButtonPrimary 
                                    onClick={dialogSubmit} 
                                    sx={{cursor: 'pointer', whiteSpace: "nowrap"}}
                                >
                                    {t('function.create_new_template')}
                                </ButtonPrimary>
                            )}
                            <ButtonSecondary onClick={() => setDialogOpen(false)}>
                                {t('common.cancel')}
                            </ButtonSecondary>
                        </Grid>
                    </DialogActions>
            </Dialog>
            <Grid container>
                {showOptions && (
                    <Grid className={'MuiGrid-item align-right'} size={12}>
                        <ButtonSpacer>
                            {componentActionButtons}
                        </ButtonSpacer>
                    </Grid>
                )}
            </Grid>
        </form>
    );
}

FunctionTemplatesFormComponent.propTypes = {
    label: PropTypes.string,
    editorActivated: PropTypes.bool,
    shared: PropTypes.bool,
    onChange: PropTypes.func,
    selectedFunction: PropTypes.object,
    selectedLocation: PropTypes.object,
    fieldErrors: PropTypes.object,
    actionButtons: PropTypes.array,
    functionTemplateButtons: PropTypes.array,
    allPartitionsOpen: PropTypes.bool,
    updateData: PropTypes.bool,
    youthData: PropTypes.object
};

const mapStateToProps = (state) => {
    // return state;
    return {
        municipalities: state.municipality.municipalities,
        selectedFunction: state.func.selectedFunction,
        selectedMunicipality: state.municipality.selectedMunicipality,
        selectedMunicipalityUsers: state.municipality.selectedMunicipalityUsers,
        selectedTemplateHandlers: state.municipality.selectedTemplateHandlers,
        organizations: state.municipality.organizations,
        organizationTree: state.municipality.organizationTree,
        locations: state.location.locations,
        locationTypes: state.root.locationTypes,
        services: state.root.services,
        contentIdentifiers: state.root.contentIdentifiers,
        methods: state.root.methods,
        templates: state.func.templates,
        func: state.func,
        authenticatedUser: state.auth.authenticatedUser
    }
}
const mapDispatchToProps = dispatch => {
    return {
        askUpdates: () => dispatch(askUpdates()),
        listMunicipalities: () => dispatch(listMunicipalities()),
        getLocation: (id, onSuccess) => dispatch(getLocation(id, onSuccess)),
        setFunction: (data) => dispatch(setFunction(data)),
        unsetFunction: () => dispatch(unsetFunction()),
        createFunction: (data, createTemplate, onSuccess, onlyTemplate) => dispatch(createFunction(data, createTemplate, onSuccess, onlyTemplate)),
        saveFunction: (id, data, onSuccess) => dispatch(saveFunction(id, data, onSuccess)),
        listFunctionTemplates: (municipalityId) => dispatch(listFunctionTemplates(municipalityId)),
        listLocations: (municipalityId) => dispatch(listLocations(municipalityId)),
        listMunicipalityUsersSilent: (municipalityId) => dispatch(listMunicipalityUsersSilent(municipalityId)),
        listOrganizations: (municipalityId) => dispatch(listOrganizations(municipalityId)),
        getOrganizationTree: (municipalityId, level) => dispatch(getOrganizationTree(municipalityId, level)),
        updateContentIdentifierChoices: (municipalityId) => dispatch(updateContentIdentifierChoices(municipalityId)),
        updateFunctionTemplate: (templateId, data, onSuccess) => dispatch(updateFunctionTemplate(templateId, data, onSuccess)),
        getYouthCardInfo: (eventId) => dispatch(getYouthCardInfo(eventId)),
        getSharedMunicipalities: (shareId) => dispatch(getSharedMunicipalities(shareId)),
        setYouthData: (data) => dispatch(setYouthData(data)),
        getMunicipality: (id) => dispatch(getMunicipality(id)),
    };
}

export const FunctionTemplatesForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation('translation')(FunctionTemplatesFormComponent));